import React from 'react'
import { IntegerRenderer } from './integerRenderer'
import { FloatRenderer } from './floatRenderer'
import { PercentageRenderer } from './percentageRenderer'
import { BoolRenderer } from './boolRenderer'
import { DateTimeRenderer } from './dateTimeRenderer'
import { reportDataType } from '@/enums/reportDataType'
import { BasicCellButtons } from '@/components/report-tables/renderers/cellButtons/basicButtons'
import { CommentButtons } from '@/components/report-tables/renderers/cellButtons/commentButtons'
import { NumberUnformattedRenderer } from '@/components/report-tables/renderers/numberUnformattedRenderer'
const reportDataTypeEnum = reportDataType.enum

export function CellRenderer (props) {
  const content = <BasicRenderer reportDataType={props.reportDataType} value={props.value} />
  return (
    <span className='cell-buttons'>
      {content}
      <CommentButtons {...props} />
      <BasicCellButtons {...props} />
    </span>
  )
}

function BasicRenderer ({ value, reportDataType }) {
  switch (reportDataType) {
    case reportDataTypeEnum.Integer:
      return <IntegerRenderer value={value} />
    case reportDataTypeEnum.Number:
      return <FloatRenderer value={value} />
    case reportDataTypeEnum.PercentageDouble:
    case reportDataTypeEnum.PercentageInt:
      return <PercentageRenderer value={value} fractionDigits={reportDataType === reportDataTypeEnum.PercentageDouble ? 2 : 0} />
    case reportDataTypeEnum.Bool:
      return <BoolRenderer value={value} />
    case reportDataTypeEnum.Date:
      return <DateTimeRenderer value={value} />
    case reportDataTypeEnum.NumberUnformatted:
      return <NumberUnformattedRenderer value={value} />
    case reportDataTypeEnum.NoType:
    case reportDataTypeEnum.String:
    default:
      return value
  }
}



// WEBPACK FOOTER //
// ./src/components/report-tables/renderers/index.js